import { useSelector } from 'react-redux';
import { Box, Button, Typography, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import ArrowIcon from 'app/assets/icons/arrow.svg?react';

export default function NavigateBack() {
  const { navigationAction } = useSelector(({ header }) => header);

  if (!navigationAction) return null;

  if (navigationAction.type === 'button') {
    return (
      <Box>
        <Button className="flex gap-16" onClick={navigationAction.callback}>
          <ArrowIcon className="text-typography-secondary stroke-typography-secondary -rotate-90" />
          <Typography className="font-700 text-16 text-typography-primary pr-8">
            {navigationAction.title}
          </Typography>
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Box className="flex items-center gap-8 mx-8">
        <Typography className="font-700 text-16 text-typography-primary">
          {navigationAction.title}
        </Typography>
        {navigationAction.tooltip && (
          <Tooltip title={navigationAction.tooltip} arrow placement="right">
            <InfoOutlinedIcon className="text-16 text-grey-600 cursor-pointer" />
          </Tooltip>
        )}
      </Box>
    </Box>
  );
}
